// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"76125e57","183":"10eb534e","343":"b974ea8b","373":"4b649475","425":"a19916e5","465":"adcf3639","484":"8ea2b0c9","500":"a142cdb3","525":"eedf4f72","550":"88edce18","648":"c13908ee","684":"81f87246","777":"3a6c10e2","840":"71a3883b","953":"c726bbde"}[chunkId] + ".chunk.js";
};